import { Alert, Input } from '@/shared/ui';
import { OtcFormFieldsProps } from './types';

export const SeparatePackagingQuantityInput = ({ values, errors, touched, setFieldValue, setErrors, handleBlur }: OtcFormFieldsProps) => (
    <div className='bg-mint-200 flex flex-col rounded-[0.8125rem] p-5 md:p-7.5'>
        <p className="font-bold atkinsonHyperlegible text-17 md:text-21 mb-4">
            What is the quantity listed on the item? (For example: 90 tablets or 100 capsules)
        </p>
        <Input
            label={"Quantity (QTY)"}
            name="quantity"
            required
            type='text'
            placeholder="ex. 90"
            value={values.quantity}
            onChange={(e) => {
                const rawValue = e.target.value;
                let sanitizedValue = rawValue.replace(/[^0-9]/g, '');
                sanitizedValue = sanitizedValue.replace(/^0+/, '');
                setFieldValue('quantity', !sanitizedValue || sanitizedValue === '0' ? null : sanitizedValue);
                setErrors({});
            }}
            onBlur={handleBlur}
            error={!!errors.quantity && !!touched.quantity}
            sx={errors.quantity && touched.quantity ? {
                "&.Mui-disabled": { "& .MuiOutlinedInput-notchedOutline": { borderColor: "red" } }
            } : {}}
            labelClassName={`${errors.quantity && touched.quantity ? 'text-red-500' : ''} !text-18 sm:!text-21`}
            testId="otc-medication-quantity-separate"
            enableNaturalEnter
        />
        {errors.quantity && touched.quantity && <Alert boldLabel={false} className='mt-[0.625rem]' label={errors.quantity} />}
    </div>
);
